const TransportList = () => import('Views/transport/transport-list');
const TransportMonitor = () => import('Views/transport/transport-monitor');
const TransportMonitorForDeviceUser = () => import('Views/transport/transport-monitor-forDeviceUser');
const TransportDeviceData = () => import('Views/transport/transport-deviceData');
const DeviceDataChart = () => import('Views/transport/deviceData-chart');
const DeviceDataCoordinate = () => import('Views/transport/deviceData-coordinate');
const DeviceShipmentList = () => import('Views/transport/device-shipment-list');

export default[
  { path: '/transport-list', component: TransportList },
  { path: '/transport-monitor', component: TransportMonitor },
  { path: '/transport-monitor-forDeviceUser', component: TransportMonitorForDeviceUser },
  { path: '/transport-deviceData/:id', component: TransportDeviceData },
  { path: '/deviceData-chart/:ids?', component: DeviceDataChart },
  { path: '/deviceData-coordinate/:ids?', component: DeviceDataCoordinate },
  { path: '/device-shipment-list', component: DeviceShipmentList },
];



// WEBPACK FOOTER //
// ./src/router/transport.js